import { render } from "./PackingListAdd.vue?vue&type=template&id=71a68bf3"
import script from "./PackingListAdd.vue?vue&type=script&lang=js"
export * from "./PackingListAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__